import React, { useState, useEffect } from 'react';
import { Row, Input, Card, CardBody, Label, Col, FormGroup } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import SelectComponent from '@componentes/select/select.component';
import { useDispatch } from 'react-redux';
import * as kanbanActions from '../store/kanban.action';
import * as commonActions from '@common/common.action';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import DragDropApi from '../dragdrop.api';
import IntlMessage from "../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

export default function Imunologia(props) {
  const [destino, setDestino] = useState([]);
  const [destinos, setDestinos] = useState([]);
  const [selectGrid, setSelectGrid] = useState(0);
  const [lista, setLista] = useState([]);
  const dispatch = useDispatch();

  const intl = useIntl()

  useEffect(() => {
    const data = props.data[Object.keys(props.data)[0]];
    if (data.length > 0) {
      reset();
      insertSelect(data);
    }
  }, [props.data]);

  useEffect(() => {
    setDestinos(props.destinos);
  }, [props.destinos]);

  useEffect(() => {
    const disabled = !selectGrid || destino.length === 0;
    dispatch(kanbanActions.atualizarMoverDisabled(disabled));
  }, [selectGrid, destino]);

  useEffect(() => {
    if (props.click) {
      moverItens();
      props.onClick();
    }
  }, [props.click]);

  function reset() {
    dispatch(kanbanActions.atualizarLamina([]));
    dispatch(kanbanActions.atualizarMoverDisabled(true));
    setLista([]);
    setSelectGrid(0);
    setDestino([]);
  }

  function selectItem(e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document
      .getElementsByClassName('kanban-imunologia-modal-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-imunologia-modal-table')[0]
      .getElementsByTagName('tr').length;

    if (checkboxes.length < items - 1)
      document.getElementById('selectMaterias').checked = false;
    else
      document.getElementById('selectMaterias').checked = true;

    for (let i = 0; i < tr.length - 1; i++) {
      let td = tr[i].getElementsByTagName('td');

      if (td.length > 0 && td[0].getElementsByTagName('input')[0])
        if (td[0].getElementsByTagName('input')[0].id === e.target.id)
          if (tr[i].getAttribute('datacheck') === 'true')
            tr[i].setAttribute('datacheck', 'false');
          else
            tr[i].setAttribute('datacheck', 'true');
    }
  }

  function onChangeSelect(e) {
    let tr = document.getElementsByTagName('tr');

    for (let i = 0; i < tr.length - 1; i++) {
      let td = tr[i].getElementsByTagName('td');

      if (td.length > 0 && td[0].getElementsByTagName('input')[0])
        if (td[0].getElementsByTagName('input')[0].id === e.data.itemId.toString())
          if (tr[i].getAttribute('datacheck') === 'true') {
            tr[i].setAttribute('datacheck', 'false');
            document.getElementById(e.data.itemId.toString()).checked = false;
          } else {
            tr[i].setAttribute('datacheck', 'true');
            document.getElementById(e.data.itemId.toString()).checked = true;
          }
    }

    let checkboxes = document
      .getElementsByClassName('kanban-imunologia-modal-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-imunologia-modal-table')[0]
      .getElementsByTagName('tr').length;

    if (checkboxes.length < items - 1)
      document.getElementById('selectMaterias').checked = false;
    else
      document.getElementById('selectMaterias').checked = true;
  }

  function toggleCheckBox(checked) {
    let checkboxes = document
      .getElementsByClassName('kanban-imunologia-modal-table')[0]
      .getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        let doc = document
          .getElementsByClassName('kanban-imunologia-modal-table')[0]
          .getElementsByTagName('tr')[i + 1];
        if (checked) {
          setSelectGrid(checkboxes.length);
          doc && doc.setAttribute('datacheck', 'true');
        } else {
          setSelectGrid(0);
          doc && doc.setAttribute('datacheck', 'false');
        }
      }
    }
  }

  function insertSelect(dados) {
    const novaLista = [];
    // eslint-disable-next-line array-callback-return
    dados.map((item, i) => {
      if (!item.isDragDisabled) {
        novaLista.push({
          itemId: item.id,
          exame: item.data.dsCasoLamina,
          tipo: item.data.tipo,
          nomeTecnico: item.data.nome,

          select: (
            <input
              className="checkbox"
              name="checkbox"
              type="checkbox"
              id={item.id}
              onClick={(e) => selectItem(e)}
            />
          ),
        });
      }
    });
    setLista(novaLista);
  }

  function getIconeStatus(value) {
    let icone, status;

    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.CG_PENDENTES.id &&
      value === quadroKanbanEnum.CG_EXECUTANDO.id
    ) {
      icone = quadroKanbanEnum.CG_EXECUTANDO.icone;
      status = quadroKanbanEnum.CG_EXECUTANDO.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.CG_PENDENTES.id &&
      value === quadroKanbanEnum.CG_PRONTAS.id
    ) {
      icone = quadroKanbanEnum.CG_PRONTAS.icone;
      status = quadroKanbanEnum.CG_PRONTAS.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.CG_PENDENTES.id &&
      value === quadroKanbanEnum.CG_PENDENTES.id
    ) {
      icone = quadroKanbanEnum.CG_PENDENTES.icone;
      status = quadroKanbanEnum.CG_PENDENTES.status;
    }

    return { icone, status };
  }

  function montarLaminas(itens, destination) {
    let laminas = [];
    for (let item of itens) {
      let lamina = item.id.split('_');
      const iconeStatus = getIconeStatus(destination);
      laminas.push({
        CdRequisicaoImuno: +lamina[3],
        lamina: +lamina[1],
        status: iconeStatus.status,
      });
    }
    return laminas;
  }

  async function moverItens() {
    dispatch(commonActions.showFadeCarregando(true));

    const data = document
      .getElementsByClassName('kanban-imunologia-modal-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');

    // Imunologia
    const payload = montarLaminas(data, destino.value);
    const laminas = { laminas: payload };
    const sendLaminas = await DragDropApi.moverLaminas(laminas);

    if (sendLaminas.success) {
      dispatch(kanbanActions.atualizarNovasLaminas(true));
      dispatch(
        commonActions.showAlerta(
          'sucesso',
          `Lâminas movidas com sucesso.`,
          1500
        )
      );
    } else {
      dispatch(
        commonActions.showAlerta(
          'erro',
          `Erro ao mover as lâminas selecionadas.`,
          1500
        )
      );
    }

    return dispatch(kanbanActions.atualizarModal(false));
  }

  return (
    <Card>
      <CardBody>
        <Row>
          <Col sm={6}>
            <FormGroup>
              <Label className="label-data" style={{ float: 'left' }}>
                {`${intl.formatMessage({ id: "dashboards.cytology.origin" })}`}
              </Label>
              <Input
                className="col-9"
                value={props.data.title && props.data.title.text}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <div className="col-6">
            <Label className="label-data col-auto" style={{ float: 'left' }}>
              {`${intl.formatMessage({ id: "dashboards.cytology.destiny" })}`}
            </Label>
            <SelectComponent
              onChange={(e) => setDestino(e)}
              className="col-auto"
              value={destino}
              options={destinos}
              placeholder={`${intl.formatMessage({ id: "dashboards.cytology.selectDestiny" })}`}
            />
          </div>
        </Row>
        <br />
        <DataTable
          className="kanban-imunologia-modal-table"
          onContextMenu={(e) => onChangeSelect(e)}
          value={lista}
          //pageLinkSize={20}
          responsive={true}
          selectionMode="single"
          style={{ height: '100%' }}
          columnResizeMode="expand"
          scrollable={true}
          //scrollHeight="50vh"
          scrollWidth="100%"
          //resizableColumns={listaDetalhes.length >= 1}
          //reorderableColumns={listaDetalhes.length >= 1}
          //rowsPerPageOptions={[10, 20, 50]}
          //rows={totalItensPage}
          lazy={true}
          paginator={false}
          //loading={carregando}
          //loadingIcon="mv-basico-menu_secundario"
          emptyMessage={<IntlMessage id="dashboards.reports.noResultsFound" />}
          alwaysShowPaginator={false}
          autoLayout={true}
        //footer={<RenderizarFooter total={totalItens} />}
        >
          <Column
            sortable={false}
            field="select"
            style={{ width: '25px', verticalAlign: 'middle' }}
            header={
              lista.length >= 1 && (
                <input
                  type="checkbox"
                  id="selectMaterias"
                  name="selectMaterias"
                  onChange={(e) => {
                    toggleCheckBox(e.target.checked);
                  }}
                />
              )
            }
          />

          <Column
            sortable={false}
            field="exame"
            style={{
              width: '150px',
              verticalAlign: 'middle',
            }}
            header={`${intl.formatMessage({ id: "general.materialArchiving.identification" })}`}
          />

          <Column
            sortable={false}
            field="tipo"
            style={{ width: '150px', verticalAlign: 'middle' }}
            header={`${intl.formatMessage({ id: 'general.materialArchiving.type' })} ${intl.formatMessage({ id: 'general.materialArchiving.material' })}`}
          />

          <Column
            sortable={false}
            field="nomeTecnico"
            style={{ width: '180px', verticalAlign: 'middle' }}
            header={<IntlMessage id="dashboards.sample.technicianName" />}
          />
        </DataTable>
      </CardBody>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/containers/imunologia.js